import { FeedbackResponse, useFeedback } from '@bbl-digital/snorre-v2'
import { usePostFeedbackMutation } from 'shared/microServices/feedback/feedback.service'
import { IFeedbackPostModel } from 'shared/microServices/feedback/Model'
import { useToaster } from './useToaster'

export const useHandleFeedback = () => {
  const [
    postFeedback,
    { isLoading: isPostingFeedback, isError: isFeedbackError },
  ] = usePostFeedbackMutation()
  const { toast } = useToaster()
  const { setOpen } = useFeedback()
  const onPostFeedback = async (feedback: FeedbackResponse) => {
    if (!feedback) return

    const model: Partial<IFeedbackPostModel> = {
      additionalProperties: {
        text: feedback.feedbackMessage,
        rating: feedback.rating,
      },
    }
    try {
      const res = await postFeedback(model)
      const isOk = res.data === 'OK'

      if (!isOk) {
        throw new Error('Det oppsto en feil under sending av tilbakemelding')
      }

      toast('Tilbakemelding ble sendt', 'success')
      setOpen(false)
    } catch (error) {
      toast(
        'Det oppsto en feil under sending av tilbakemelding. Prøv igjen senere',
        'danger'
      )
      console.error(error)
    }
  }

  return { onPostFeedback, isPostingFeedback, isFeedbackError }
}
